import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid default-dashboard" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'
import { series2, chartOptions2 } from "@/core/data/dashboards-chart"

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexDefault',
  setup(__props) {

const WelcomView = defineAsyncComponent(() => import("@/components/theme/dashboards/default/WelcomView.vue"))
const EarningsTrend = defineAsyncComponent(() => import("@/components/theme/dashboards/default/EarningsTrend.vue"))
const JobData = defineAsyncComponent(() => import("@/components/theme/dashboards/default/JobData.vue"))
const TransitionHistory = defineAsyncComponent(() => import("@/components/theme/dashboards/default/TransitionHistory.vue"))
const Auditlog = defineAsyncComponent(() => import("@/components/theme/dashboards/default/Auditlog.vue"))
const TotalInvestment = defineAsyncComponent(() => import("@/components/theme/dashboards/default/TotalInvestment.vue"))
const LatestActivity = defineAsyncComponent(() => import("@/components/theme/dashboards/default/LatestActivity.vue"))
const MonthlyRevenue = defineAsyncComponent(() => import("@/components/common/MonthlyRevenue.vue"))
const TopUsers = defineAsyncComponent(() => import("@/components/theme/dashboards/default/TopUsers.vue"))
const NewsUpdate = defineAsyncComponent(() => import("@/components/theme/dashboards/default/NewsUpdate.vue"))
const TotalInvest = defineAsyncComponent(() => import("@/components/theme/dashboards/default/TotalInvest.vue"))
const ManageInvoice = defineAsyncComponent(() => import("@/components/theme/dashboards/default/ManageInvoice.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Dashboard",
      defaultdesc: "true",
      mains: "Default Dashboard",
      title: "Default"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(WelcomView)),
        _createVNode(_unref(EarningsTrend)),
        _createVNode(_unref(JobData)),
        _createVNode(_unref(TransitionHistory)),
        _createVNode(_unref(Auditlog)),
        _createVNode(_unref(TotalInvestment)),
        _createVNode(_unref(LatestActivity)),
        _createVNode(_unref(MonthlyRevenue), {
          colClass: "col-lg-6 proorder-xxl-6 box-col-12",
          cardClass: "card growthcard",
          series: _unref(series2),
          option: _unref(chartOptions2)
        }, null, 8, ["series", "option"]),
        _createVNode(_unref(TopUsers)),
        _createVNode(_unref(NewsUpdate)),
        _createVNode(_unref(TotalInvest)),
        _createVNode(_unref(ManageInvoice))
      ])
    ])
  ], 64))
}
}

})